"use strict";
exports.__esModule = true;
exports.SetupAutopilotAction = exports.ActionLogType = void 0;
var ActionLogType;
(function (ActionLogType) {
    ActionLogType["CREATE_CARD"] = "CREATE_CARD";
    ActionLogType["USER_ACCOUNT_CREATE"] = "USER_ACCOUNT_CREATE";
    ActionLogType["ACCEPT_OFFER"] = "ACCEPT_OFFER";
    ActionLogType["RESTART_ONBOARDING"] = "RESTART_ONBOARDING";
    ActionLogType["CREATE_CUSTOMER_ACCOUNT"] = "CREATE_CUSTOMER_ACCOUNT";
    ActionLogType["UPDATE_CUSTOMER_ACCOUNT"] = "UPDATE_CUSTOMER_ACCOUNT";
    ActionLogType["INITIATE_OFFER"] = "INITIATE_OFFER";
    ActionLogType["EVALUATE_OFFER"] = "EVALUATE_OFFER";
    ActionLogType["SETUP_AUTOPILOT"] = "SETUP_AUTOPILOT";
    ActionLogType["SKIP_AUTOPILOT"] = "SKIP_AUTOPILOT";
    ActionLogType["APPROVE_CONFIRMATION"] = "APPROVE_CONFIRMATION";
    ActionLogType["ENABLE_SIMPLIFIED_PAYMENTS"] = "ENABLE_SIMPLIFIED_PAYMENTS";
    ActionLogType["DISABLE_SIMPLIFIED_PAYMENTS"] = "DISABLE_SIMPLIFIED_PAYMENTS";
    ActionLogType["SELECT_PRODUCT_CREDIT_BUILDER"] = "SELECT_PRODUCT_CREDIT_BUILDER";
    ActionLogType["SELECT_PRODUCT_SPLIT_RENT"] = "SELECT_PRODUCT_SPLIT_RENT";
    ActionLogType["VALUE_PROP"] = "VALUE_PROP";
})(ActionLogType = exports.ActionLogType || (exports.ActionLogType = {}));
var SetupAutopilotAction;
(function (SetupAutopilotAction) {
    SetupAutopilotAction["EPISODIC_ON"] = "EPISODIC_ON";
    SetupAutopilotAction["AUTOPAY_ON"] = "AUTOPAY_ON";
})(SetupAutopilotAction = exports.SetupAutopilotAction || (exports.SetupAutopilotAction = {}));
